@if (isModal()) {
  <div class="modal-header d-print-none">
    <app-summary-top
      class="w-100"
      [header]="header()"
      [name]="baseService()?.name"
      [model$]="model$()"
      [showCopy]="showCopy()"
      [showSave]="showSave()"
      [showBack]="showBack()"
      [additionalButtons]="additionalButtons()"
      [summaryItems]="summaryItems()"
      [copyButtonText]="copyButtonText()"
      [enableCopyButton]="enableCopyButton()"
      [overrideSave]="saveClicked$.observed"
      [previousNext]="previousNext()"
      (saveClicked)="saveClicked$.next()"
      (copyModel)="copyModel.emit()"
      (movePrevious)="movePrevious.emit($event)"
      (moveNext)="moveNext.emit($event)"
    ></app-summary-top>
  </div>
  <div class="modal-body p-3">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  </div>
} @else {
  <app-summary-top
    class="w-100"
    [header]="header()"
    [name]="baseService()?.name"
    [model$]="model$()"
    [showCopy]="showCopy()"
    [showSave]="showSave()"
    [showBack]="showBack()"
    [additionalButtons]="additionalButtons()"
    [summaryItems]="summaryItems()"
    [copyButtonText]="copyButtonText()"
    [enableCopyButton]="enableCopyButton()"
    [overrideSave]="saveClicked$.observed"
    [previousNext]="previousNext()"
    (saveClicked)="saveClicked$.next()"
    (copyModel)="copyModel.emit()"
    (movePrevious)="movePrevious.emit($event)"
    (moveNext)="moveNext.emit($event)"
  ></app-summary-top>
  <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
}

<ng-template #contentTpl>
  <ng-content></ng-content>
</ng-template>
